<f-data-card>
  <div class="container approved-exceptions">
    <div class="row">
      <h5>Approved Exceptions</h5>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6 approved-exceptions-left">
        <section *ngIf="rootScope.customerTypeAPIFailure" class="error-wrapper">
          <f-alert variant="error">
            {{errorMsg}}
            <button (click)="apiService.getCustomerTypesAPI()" class="btn-alert">Try again</button>
          </f-alert>
        </section>
        <section *ngIf="rootScope.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIFailure"
          class="error-wrapper">
          <f-alert variant="error">
            {{errorMsg}}
            <button (click)="getExceptionandSubExceptionType()" class="btn-alert">Try again</button>
          </f-alert>
        </section>
        <section *ngIf="rootScope.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIConfigMiss"
          class="error-wrapper">
          <f-alert variant="error">
            {{rootScope.exceptionTypeandSubTypeAPIConfigMissErrorMsg}}
          </f-alert>
        </section>
        <section *ngIf="rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss"
          class="error-wrapper">
          <f-alert variant="error">
            {{credentialErrorMsg}}
          </f-alert>
        </section>
        <section *ngIf="rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure"
          class="error-wrapper">
          <f-alert variant="error">
            {{errorMsg}}
            <button (click)="getCredetialData()" class="btn-alert">Try again</button>
          </f-alert>
        </section>
        <div class="card-row">
          <ol>
            <!--label (Caller/Customer Type) name change for CCR1-5039-->
            <li> Select a Caller/Customer Type to determine which Approved Exceptions can be selected.
              <app-alight-drop-down [group]="rootScope.customerTypeForm" [controlName]="'customerType'"
                [required]="false" description="fieldValueDescription" [disable]="customerAccountService.callerTypeValidation()" label="Caller/Customer Type"
                [value]="'fieldValue'" [list]="rootScope.customerTypeData" (change)="changeCustomerType($event)">
              </app-alight-drop-down>
            </li>
            <li> Select an Approved Exception Type and Subtype.

              <app-alight-drop-down [group]="rootScope.approvedTypeExceptionForm" [controlName]="'type'"
                [required]="false" description="exception_description" [disable]="false"
                label="Select an Exception Type" [value]="'exception_description'" [list]="rootScope.exceptionsList"
                (change)="changeExceptionType($event)"> </app-alight-drop-down>

              <app-alight-drop-down class="exception-subtype" [group]="rootScope.approvedTypeExceptionForm"
                [controlName]="'subType'" [required]="false" description="exception_subtype_description"
                [disable]="rootScope.activeCustTab.approvedExceptionsTypes?.selectedException ? false : true"
                label="Select an Exception Subtype" [value]="'exception_subtype_description'" [list]="rootScope.subExceptionsList"
                (change)="changeSubExceptionType($event)"> </app-alight-drop-down>
            </li>

            <li> Verify the required data to proceed with this Exception Type/Subtype.
              <f-alert variant="info" *ngIf="(!rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData || 
                rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData.length == 0)">
                {{approvedExceptionNotSelected}}
              </f-alert>
              <div class="caller-detail" *ngIf="rootScope.activeCustTab.approvedExceptionCredentialData?.selectedCredentialData &&
                rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData.length > 0">
                <ul>
                  <span
                    *ngFor="let group of rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData">
                    <span *ngFor="let section of group?.subgroups[0]?.sections">
                      <span *ngFor="let subsection of section?.sectionsubgroups">

                        <div *ngFor="let element of subsection?.elements">
                          <div class="no-bullet" *ngIf="isCredsLabel(element)" > 
                           <!--Add UI class in div-->
                            <div class="ap-no-bullet">
                              <div [ngClass]="this.getNgclass(element)" [innerHTML]="checkforEmptyCredValues(element.values) ? element?.key : element?.key"></div>                                           
                            </div>
                          </div>
                          
                          <li *ngIf="!this.isCredsLabel(element)">
                            <div class="data-label">{{ checkforEmptyCredValues(element.values) ? element?.key : element?.key + ':' }}</div>
                            <div class="data-value" *ngFor="let v of element?.values">{{ v?.value != 'NA' ? v?.value : '' }}
                              <span  *ngIf="customerAccountService.checkIVRConfirmation(section)" class="data-verified "><i class="fa-light fa-circle-check"></i> Confirmed via IVR</span>
                            </div>
                          </li>
                        
                        </div>
                      </span>
                    </span>
                  </span>
                </ul>
              </div>
            </li>
          </ol>

          <div class="data-confirmation" *ngIf="rootScope.activeCustTab.approvedExceptionCredentialData?.selectedCredentialData &&
            rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData.length > 0">

            <section *ngIf="rootScope.activeCustTab.deleteExpireAlertApiFailure" class="error-wrapper">
              <f-alert variant="error">
                There was an issue expiring the Security Override Alert. Please try again by clicking the Continue button.
              </f-alert>
            </section>
            <div class="consent-slider">
              <p>Has the information above been confirmed with the caller? </p>
              <span class="slider">No <mat-slide-toggle (change)="onToggleChange($event)"
                  [(ngModel)]="this.rootScope.activeCustTab.approvedExceptionToggleValue"
                  [disabled]=!isLiveInteraction()>Yes</mat-slide-toggle> </span>
            </div>

            <section class="error-wrapper status-msg" *ngIf="rootScope.activeCustTab.approvedExceptionSuccessMsg">
              <f-alert variant="success">
                <strong>Success! The caller is now authorized for this Approved Exception.</strong> Select Continue to
                proceed.
              </f-alert>
            </section>

            <div class="button-controls">
              <f-button text="Reset"  title="Reset" type="button" variant="action" (buttonClicked)=resetApprovedExceptionPage()>
              </f-button>
              <f-button text="Continue" title="Continue" type="button" variant="progressive" (buttonClicked)=actionsOnContinue()
                [disabled]=checkApprovedExceptionContinue()></f-button>
            </div>
          </div>
        </div>

      </div>
      <div class="col-md-6 col-lg-6 approved-exceptions-right">

        <div class="approved-exceptions-content">
          <p>Only the information/action noted for a specific Approved Exception is allowed.</p>
          <section *ngIf="rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss"
            class="error-wrapper">
            <f-alert variant="error">
              {{egainContentErrorMsg}}
            </f-alert>
          </section>
          <section *ngIf="rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure"
            class="error-wrapper">
            <f-alert variant="error">
              {{errorMsg}}
              <button (click)="getEgainContentData()" class="btn-alert">Try again</button>
            </f-alert>
          </section>
          <f-alert *ngIf="!rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException"
            variant="info">{{approvedExceptionNotSelected}}</f-alert>

          <h5><strong>{{rootScope.activeCustTab?.approvedExceptionEgainContentData?.selectedEgainContent?.name}}</strong></h5>
          <div class="authentication-content"
            [innerHTML]="rootScope.activeCustTab?.approvedExceptionEgainContentData?.selectedEgainContent?.content">
          </div>

          <div class="care-portal-links">
           <span *ngIf="rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure">
            <h4>Resources</h4>
            <section 
            class="error-wrapper">
            <f-alert variant="error">
              {{errorMsg}}
              <button (click)="getResourceLinksData()" class="btn-alert">Try again</button>
            </f-alert>
          </section>
        </span>
         <span *ngIf=" rootScope.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData && rootScope.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData.length > 0">  
          <h4>Resources</h4>
            <section  *ngIf="rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss"
            class="error-wrapper">
            <f-alert variant="error">
              {{resourceErrorMsg}}
            </f-alert>
          </section>
            <ng-container *ngFor="let menu of rootScope.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData">
              <h4 class="font-normal">{{menu?.heading}}</h4>
                <section *ngIf="!menu?.id" class="error-wrapper">
                  <f-alert variant="error">
                    <p class="full-width"> {{menu?.actionCode}} </p>
                  </f-alert>
                </section>
                <ul>
                    <li *ngFor="let subMenu of (menu?.subMenuList | sortBy: 'heading')" >
                      <ng-container *ngIf='!enableLink(menu)'>
                       <button [ngClass]="{'disabledLink': enableLink(menu)}"
                          (click)="TbaLinkClick(subMenu)">{{subMenu?.heading}}<i
                            class="fa-solid fa-arrow-up-right-from-square"></i></button>
                      </ng-container>
                      <ng-container *ngIf='enableLink(menu)'>
                        <button [ngClass]="{'disabledLink': enableLink(menu)}" disabled
                          (click)="TbaLinkClick(subMenu)">{{subMenu?.heading}}<i
                            class="fa-solid fa-arrow-up-right-from-square"></i></button>
                      </ng-container>
                    </li>
                </ul>
            </ng-container>
          </span>

          </div>
          
<!-- CCR6-2063 -->
        <div  *ngIf="this.isApproveExceptionTBAConfigured()" class="tba-alert-section">
          <f-alert variant="info">
            No additional resources configured.
          </f-alert>
        </div>
        <!-- CCR1-8878 -->
        <div class="current-coverage" *ngIf="showHealthCoverageApprovedException()">

          <div class="container">
            <div class="row">
             
              <div class="col-md-12">
                <div class="current-coverage-header">
                  <h6>Current Health Coverage</h6>
                  
                  <!-- Place a refresh button on left section CCR6-1978  -->
                  <button *ngIf="rootScope.activeCustTab.approvedExceptionHealthCardData.healthCardApiFailure"  (click)="customerAccountService.getHealthCoverageData()"    color="primary" title="Refresh" class="refresh-button">
                    <i class="fa-solid fa-arrows-rotate"></i>
                  </button> 
                  
                </div>                      
              </div>
            </div>
            <div class="row">   
              <div class="col-md-12">
                <div class="current-coverage-content">                  

                  <f-alert variant="warning" *ngIf="rootScope.activeCustTab.approvedExceptionHealthCardData.healthCardConfigMiss">
                    There is no data available.
                  </f-alert>
                  <f-alert variant="error" *ngIf="rootScope.activeCustTab.approvedExceptionHealthCardData.healthCardApiFailure">
                    There was a problem loading the data. Try again by clicking the Refresh icon.
                   </f-alert>
                 
                  <div class="subscription-table">

                      <div *ngFor="let item of rootScope.activeCustTab.approvedExceptionHealthCardData.healthCardData" class="subscription-row">
                        <span class="subscription-label">{{item.planType}}</span>
                        <span class="subscription-value">{{item.planDescription}} <br/>
                          {{item.planDependents}}</span>    
                      </div>

                   </div>

                </div>
               </div>
            </div> 
          </div>  


        </div>
         <!-- CCR1-10277 person internal Id-->
        <div class="current-coverage hide">

          <div class="container">
            <div class="row">
             
              <div class="col-md-12">
                <div class="current-coverage-header">
                  <h6>Person Internal ID</h6>
                </div>                      
              </div>
            </div>
            <div class="row">   
              <div class="col-md-12">
                <div class="current-coverage-content">                  

                  <f-alert variant="warning" >
                    There is no data available.
                  </f-alert>
                  <f-alert variant="error" >
                        There was problem loading the data. <a href="javascript:void('0')"
                            class="btn-alert">Try again.</a>
                    
                  </f-alert>
                 
                  <div class="subscription-table ">
                    <div class=" subscription-row ">
                      <span class="col-md-4 subscription-label">Platform Type</span>
                      <span class="col-md-4 subscription-label">Domain</span>
                      <span class="col-md-4 subscription-label">Person Internal Id</span>
                    </div>
                    <div *ngFor="let item of samplePersonInternalIdData" class=" subscription-row">
                      <span class="col-md-4 subscription-value">{{item.platformType}}</span>
                      <span class="col-md-4 subscription-value">{{item.domain}}</span>
                      <span class="col-md-4 subscription-value">{{item.personInternalId}}</span>
                    </div>
                  </div>

                </div>
               </div>
            </div> 
          </div>  

        </div>

        </div>

      </div>
    </div>



  </div>
</f-data-card>